export default {
	SubmissionId: 'Mã giao dịch',
	LicenseInfo: 'Thông tin dịch vụ',
	YearUsing: 'Thời hạn sử dụng:',
	Year: 'năm',
	StartDate: 'Ngày bắt đầu sử dụng:',
	ExpriedDate: 'Ngày hết hạn sử dụng:',
	OrderNo: 'Số đơn hàng',
	TotalAmount: 'Số tiền',
	PaymentMethod: 'Hình thức thanh toán',
	OrderDate: 'Ngày đặt hàng',
	PaymentStatus: 'Tình trạng thanh toán',
	SearchOrderNo: 'Nhập số đơn hàng, tình trạng thanh toán để tìm kiếm',
	ReasonStop: 'Vui lòng cho chúng tôi biết lý do',
	Reason: 'Lý do',
	DescriptionPay: 'Nội dung chuyển tiền',
	Subtitle:
		'Quý khách vui lòng nhập chính xác nội dung chuyển tiền ghi trong Uỷ nhiệm chi và đính kèm hình ảnh Uỷ nhiêm chi để MISA xác định đã thanh toán',
	SubtitleHelp: 'Quý khách vui lòng thanh toán theo thông tin sau',
	TitleAddFile: 'Thêm tệp đính kèm',
	PlaceHolderFile: 'Hình ảnh chứng từ chuyển tiền, ủy nhiệm chi,...',
	ErrorSelectImg: 'Vui lòng đính kèm hình ảnh chứng từ',
	ResourceStatus: 'Tình trạng cấp tài nguyên',
	InvoiceStatus: 'Tình trạng xuất hóa đơn',
	EsignStatus: 'Tình trạng cấp dịch vụ eSign',
	EsignSuccess: 'Đã cấp dịch vụ eSign',
	EsignFail: 'Chưa cấp dịch vụ eSign',
	ItemName: 'Gói sản phẩm',
	Unit: 'Đơn vị tính',
	Quantity: 'Số lượng',
	UnitPrice: 'Đơn giá',
	Amount: 'Thành tiền',
	InvoiceSuccess: 'Đã xuất hóa đơn',
	InvoiceFail: 'Chưa xuất hóa đơn',
	ResourceSuccess: 'Đã cấp tài nguyên MISA mTax',
	ResourceFail: 'Chưa cấp tài nguyên MISA mTax',
	TotalAmount: 'Tổng tiền',
	PromotionAmount: 'Giảm giá',
	TotalTaxAmount: 'Tổng tiền thuế',
	TotalSaleAmount: 'Tổng tiền thanh toán',
	AccountPay: 'ĐƠN VỊ THỤ HƯỞNG',
	AccountName: 'Tên tài khoản',
	AccountNumber: 'Số tài khoản',
	AccountBank: 'Mở tại',
	AccountDescription: 'Nội dung chuyển tiền',
	ToastCancelOrderSuccess: 'Hủy đơn hàng thành công',
	NoData: 'Chưa có',
	OverDateYear: 'Hết hạn',
	TitleAcceptSuccess: 'XÁC NHẬN THANH TOÁN THÀNH CÔNG',
	SubTitleAcceptSuccess:
		'MISA sẽ cấp tài nguyên cho quý khách ngay sau khi xác nhận  thông tin quý khách cung cấp',
	DropAndDragOr: 'Kéo và thả tệp vào đây hoặc',
	ClickTo: 'nhấn để ',
	SelectFile: 'chọn tệp',
	SelectFileComputer: ' từ máy tính',
	SelectFileComputerAgain: 'chọn lại',
	OverDate:
		'Thời hạn sử dụng dịch vụ MISA mTax đã hết. Vui lòng đặt mua thêm để tiếp tục sử dụng dịch vụ.',
	LessDate:
		'Thời hạn sử dụng dịch vụ MISA mTax sắp hết. Vui lòng đặt mua thêm để không bị gián đoạn công việc của bạn.',
	NotBuy: 'Bạn chưa đặt mua MISA mTax. Vui lòng đặt mua để sử dụng dịch vụ.',
	NotAccept:
		'Bạn chưa thanh toán đơn hàng mua MISA mTax. Vui lòng thanh toán đơn hàng để sử dụng dịch vụ.',
	NotNumberAccept1: 'Bạn còn ',
	NotNumberAccept2:
		' đơn hàng chưa thanh toán. Nếu quý khách đã thanh toán, vui lòng xác nhận thanh toán để MISA kiểm tra lại thông tin.',
	WarningActive: (link, storeName, companyName, taxCode) => 'Mã kích hoạt được cấp cho mỗi đơn hàng đặt mua trên <a href="' + link + '" target="_blank" class="text-link" style="color: #1877f2;">' + storeName + '</a>. Nhập mã kích hoạt để MISA xác thực giấy phép sử dụng cho <span style="font-family: SFProDisplayMedium">' + companyName + '  (' + taxCode + ')</span>',
	PlaceHolderActive: 'Nhập mã kích hoạt',
	ActiveStoreSuccess: 'Kích hoạt giấy phép sử dụng thành công',
	StoreKey: "Mã kích hoạt",
};
